import script from "./TabListItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TabListItem.vue?vue&type=script&setup=true&lang=js"

import "./style.css?vue&type=style&index=0&id=35d3dbe9&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35d3dbe9"]])

export default __exports__